import type { Company } from '@models/company'
import type { AxiosError } from 'axios'
import ms from 'ms'
import { useQuery } from 'react-query'
import companyApi from './actions'
import { companiesKeys } from './constants'

export interface UseCompaniesData {
  companies: Company[]
  companiesMap: Map<number, Company>
}

export const selectData = (data: Company[]): UseCompaniesData => {
  return {
    companies: data,
    companiesMap: new Map(data.map(company => [company.id, company])),
  }
}

const useCompanies = () => {
  const query = useQuery<Company[], AxiosError, UseCompaniesData>(
    companiesKeys.root,
    companyApi.getCompanies,
    {
      select: selectData,
      staleTime: ms('10m'),
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  )

  return query
}

export default useCompanies
